import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { enumData, loading } from '@/decorators';
import userLimit from '@/decorators/modules/userLimit';
import productModal from './productModal.vue';
import logModal from './logModal.vue';

var ProductBatch = function (_super) {
  __extends(ProductBatch, _super);

  function ProductBatch() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.productStatus = [];
    _this.total = 0;
    _this.statusCountList = [{
      status: -1,
      count: 21
    }, {
      status: 0,
      count: 20
    }, {
      status: 1,
      count: 1
    }];
    _this.tableData = [];
    _this.loadingStatus = false;
    _this.searchData = _this.initSearchData();
    return _this;
  }

  ProductBatch.prototype.initSearchData = function () {
    return {
      enable_status: undefined,
      page_index: 1,
      page_size: 20
    };
  };

  Object.defineProperty(ProductBatch.prototype, "productStatusList", {
    get: function get() {
      return this.$util.mergeCountDataToStatusEnum(this.productStatus, this.statusCountList, {
        text: this.t('全部'),
        value: undefined,
        total: 0
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ProductBatch.prototype, "columns", {
    get: function get() {
      return [{
        title: this.t('批次类型'),
        dataIndex: 'service_name',
        filterEmpty: true
      }, {
        title: this.t('生产批次号总长度'),
        dataIndex: 'batch_length',
        filterEmpty: true
      }, {
        title: this.t('前缀'),
        dataIndex: 'batch_prefix',
        filterEmpty: true
      }, {
        title: this.t('后缀'),
        dataIndex: 'batch_suffix',
        filterEmpty: true
      }, {
        title: this.t('时间'),
        scopedSlots: {
          customRender: 'time'
        }
      }, {
        title: this.t('状态'),
        dataIndex: 'enable_status_text',
        filterEmpty: true
      }, {
        title: this.t('操作'),
        width: 220,
        scopedSlots: {
          customRender: 'operation'
        }
      }];
    },
    enumerable: false,
    configurable: true
  });

  ProductBatch.prototype.created = function () {
    this.queryList();
    console.log('this.productStatus :>> ', this.productStatus);
  };

  ProductBatch.prototype.handleStatusChange = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log('value :>> ', value);
            this.searchData.enable_status = value;
            return [4, this.queryList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ProductBatch.prototype.queryList = function () {
    var _a, _b;

    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.batchAttribute.queryBatchRuleList(this.searchData)];

          case 1:
            res = _c.sent();
            this.tableData = ((_a = res.data) === null || _a === void 0 ? void 0 : _a.list) || [];
            this.total = +((_b = res.data) === null || _b === void 0 ? void 0 : _b.total) || 0;
            return [2];
        }
      });
    });
  };

  ProductBatch.prototype.handleSuccess = function (mode) {
    if (mode === 'add') {
      this.searchData.page_index = 1;
      this.queryList();
    } else {
      this.queryList();
    }
  };

  ProductBatch.prototype.handlePageChange = function (pageIndex, pageSize) {
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.queryList();
  };

  ProductBatch.prototype.handleAdd = function () {
    this.$refs.productModalRef.open('add');
  };

  ProductBatch.prototype.handleCopy = function (record) {
    this.$refs.productModalRef.open('copy', record);
  };

  ProductBatch.prototype.handleEdit = function (record) {
    this.$refs.productModalRef.open('edit', record);
  };

  ProductBatch.prototype.getUpdateParams = function (record, enable_status) {
    return __assign(__assign({}, record), {
      enable_status: enable_status
    });
  };

  ProductBatch.prototype.handleEnable = function (record) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否启用当前生产批次规则'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, void 0, function () {
          var data;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                data = this.getUpdateParams(record, 1);
                return [4, this.$api.batchAttribute.updateBatchRule(data)];

              case 1:
                _a.sent();

                this.$message.success(this.t('操作成功'));
                this.queryList();
                return [2];
            }
          });
        });
      }
    });
  };

  ProductBatch.prototype.handleDisable = function (record) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否停用当前生产批次规则'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, void 0, function () {
          var data;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                data = this.getUpdateParams(record, 0);
                return [4, this.$api.batchAttribute.updateBatchRule(data)];

              case 1:
                _a.sent();

                this.$message.success(this.t('操作成功'));
                this.queryList();
                return [2];
            }
          });
        });
      }
    });
  };

  ProductBatch.prototype.handleLog = function (record) {
    this.$refs.logModalRef.open(record);
  };

  __decorate([enumData('BoolStatusEnum')], ProductBatch.prototype, "productStatus", void 0);

  __decorate([loading('loadingStatus')], ProductBatch.prototype, "queryList", null);

  __decorate([userLimit()], ProductBatch.prototype, "handleDisable", null);

  ProductBatch = __decorate([Component({
    components: {
      productModal: productModal,
      logModal: logModal
    }
  })], ProductBatch);
  return ProductBatch;
}(Vue);

export default ProductBatch;